export default "__VITE_ASSET__8b7645a7__"